export default function TenantLogo({
  tenantConfig,
  size = "large",
  rounded = "full",
  className = "",
}) {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12",
    large: "w-16 h-16",
    xlarge: "w-24 h-24",
  };

  const iconSizes = {
    small: "w-4 h-4",
    medium: "w-6 h-6",
    large: "w-8 h-8",
    xlarge: "w-12 h-12",
  };

  const radius = {
    full: "rounded-full",
    lg: "rounded-xl",
    none: "",
  };

  const color = tenantConfig?.color_primario || "#ea580c";

  if (tenantConfig?.logo) {
    return (
      <img
        src={tenantConfig.logo}
        alt={tenantConfig?.nombre || "Logo"}
        className={`${sizeClasses[size]} ${radius[rounded]} object-contain ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} ${radius[rounded]} flex items-center justify-center border-2 ${className}`}
      style={{
        borderColor: color,
        backgroundColor: `${color}20`,
      }}
      aria-label="Logo del gimnasio"
    >
      <svg
        className={iconSizes[size]}
        fill="currentColor"
        viewBox="0 0 24 24"
        style={{ color }}
        aria-hidden="true"
      >
        <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z" />
      </svg>
    </div>
  );
}
